module.exports = __webpack_public_path__ + "static/media/spacedRep.cffadc95.png";